/* eslint-disable import/no-extraneous-dependencies */
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as cartPageActions from '../../../../services/Cart/actions';
import * as taggingActions from '../../../Common/Tagging.js/actions';
import * as loaderActions from '../../../../components/common/Loader/action';
import { getPlansData, checkPlanReferenceData } from '../../../../utils/plansReference';
import injectReducer from '../../../../utils/injectReducer';
import addons from '../../../Addons/reducer';
import * as addonActions from '../../../Addons/actions';
import { getSession } from '../../../../components/common/Helpers/index';
import DueToday from '../../../../components/Web/Cart/redesign/Components/dueToday';

const mapStateToProps = (state) => {
  const isResumeOrder = getSession('isResumeOrder');
  const cartStateProSetup= state.cartDetails?.cartDetailsJson?.cart5GAppointment;
  const cartState = state.cartDetails ? state.cartDetails.cartDetailsJson.dueTodayList : {};
  const cartStateDueMonthly = state.cartDetails ? state.cartDetails.cartDetailsJson.dueMonthlyList : {};
  const orderDetailsState = state.cartDetails ? state.cartDetails.cartDetailsJson.orderDetailsView : {};
  const shippingDetailsState = state.cartDetails ? state.cartDetails.cartDetailsJson.shippingDetails : {};
  const dueTodayTaxesState = state.cartDetails ? state.cartDetails.cartDetailsJson.dueTodayTaxes : {};
  let plansReferenceData = {};
  if (isResumeOrder === 'Y') {
    plansReferenceData = checkPlanReferenceData(state.plansReferenceData);
  }
  plansReferenceData = getPlansData(state.plansReferenceData);
  const loader = state.loader || {};
  const currentView = state.currentView || {};
  const planState = state.homePlans ? state.homePlans.plansJson : {};
  const EUPDetailsState = state.cartDetails ? state.cartDetails.cartDetailsJson.EUPDetails : {};
  const creditFlow = state.creditCheckDetails?.creditReviewSuccessResponse?.serviceResponse?.context?.cartInfo?.creditFlow;
  const downPaymentAmt = state.creditCheckDetails?.creditReviewSuccessResponse?.serviceResponse?.context?.cartInfo?.downPaymentAmount;
  const isQuantityChanged = state.cartDetails ? state.cartDetails.isQuantityChanged : {};
  const addonsData = state.addons || {};
  const showAddNotification = addonsData && addonsData.showAddNotification;
  const addOnLoadingDone = state?.cartDetails?.loadingDone;
  const throttleValue = state.SessionValues?.fwaCradleValues;
  const cradleApicompleted = state.SessionValues?.apiCompleted;
  const taggingApiCompleted = state.tagging?.readDlPlans;
  const taggingApiFlag = state.tagging?.taggingApiFlag;

  return {
    throttleValue,
    taggingApiCompleted,
    cradleApicompleted,
    taggingApiFlag,
    cartDetails: cartState || [],
    cartDetailsDueMonthly: cartStateDueMonthly || [],
    orderDetails: orderDetailsState || null,
    shippingDetails: shippingDetailsState || null,
    dueTodayTaxesDetails: dueTodayTaxesState || null,
    plansReferenceData: plansReferenceData || null,
    ltePlans: planState,
    creditFlow,
    downPaymentAmt,
    loader,
    currentView,
    EUPDetails: EUPDetailsState || null,
    isQuantityChanged,
    showAddNotification,
    addOnLoadingDone,
    cartStateProSetup,
  };
};
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...cartPageActions, ...loaderActions, ...addonActions, ...taggingActions }, dispatch);
}

const withReducer = compose(injectReducer({ key: 'addons', reducer: addons }));

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default withRouter(compose(withConnect, withReducer)(DueToday));
